import { atom } from "jotai";

export const isDisplayDrawerAtom = atom(false);
